import { Box, styled } from '@mui/material'

export const PopperWrap = styled(Box)({
  pointerEvents: 'auto',
  maxHeight: '40vh',
  overflow: 'auto',
  '&::-webkit-scrollbar': {
    width: '0.5em',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.1)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ccc',
    outline: '1px solid #efefef',
    borderRadius: '0.05em',
  },
  '& +.MuiTooltip-arrow.left': {
    left: '10% !important',
  },
  '& +.MuiTooltip-arrow.center': {
    left: 'calc(50% - 7px) !important',
  },
  '& +.MuiTooltip-arrow.right': {
    left: '90% !important',
  },
})
